export const visit = (vm, at) => {
at({ "id": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} dari {{totalBytes}}" }, "fileSizeLimit": "File tidak boleh lebih besar dari {{size}}", "screenCapture": "Tangkapan layar" } } });
};